import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'claytor/20170510_062250.jpg' satisfies MediaPath
const a = 'claytor/20170510_062258.jpg' satisfies MediaPath
// TODO: replace placeholder images with real 2024 photos

export const meta: EntryMeta = {
	slug: '2024',
	name: '2024',
	excerpt: 'Selected frames',
	tags: ['photography'],
	cover,
	order: 110,
}

export default function Year2024() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2024' },
					{ src: a, alt: '2024' },
				]}
			/>
		</>
	)
}
